/* eslint-disable max-lines */
export const icons = import.meta.glob('./src/icons/*.vue', { eager: true, import: 'default' });
export { default as DtIconAlertCircle } from './src/icons/alert-circle.vue';
export { default as DtIconAlertTriangle } from './src/icons/alert-triangle.vue';
export { default as DtIconBellMinus } from './src/icons/bell-minus.vue';
export { default as DtIconBellOff } from './src/icons/bell-off.vue';
export { default as DtIconBellPlus } from './src/icons/bell-plus.vue';
export { default as DtIconBellRing } from './src/icons/bell-ring.vue';
export { default as DtIconBell } from './src/icons/bell.vue';
export { default as DtIconConciergeBell } from './src/icons/concierge-bell.vue';
export { default as DtIconFlame } from './src/icons/flame.vue';
export { default as DtIconMegaphoneOff } from './src/icons/megaphone-off.vue';
export { default as DtIconMegaphone } from './src/icons/megaphone.vue';
export { default as DtIconNewspaper } from './src/icons/newspaper.vue';
export { default as DtIconSiren } from './src/icons/siren.vue';
export { default as DtIconSnooze } from './src/icons/snooze.vue';
export { default as DtIconArrowDownLeft } from './src/icons/arrow-down-left.vue';
export { default as DtIconArrowDownRight } from './src/icons/arrow-down-right.vue';
export { default as DtIconArrowDown } from './src/icons/arrow-down.vue';
export { default as DtIconArrowLeftRight } from './src/icons/arrow-left-right.vue';
export { default as DtIconArrowLeft } from './src/icons/arrow-left.vue';
export { default as DtIconArrowRight } from './src/icons/arrow-right.vue';
export { default as DtIconArrowUpDown } from './src/icons/arrow-up-down.vue';
export { default as DtIconArrowUpLeft } from './src/icons/arrow-up-left.vue';
export { default as DtIconArrowUpRight } from './src/icons/arrow-up-right.vue';
export { default as DtIconArrowUp } from './src/icons/arrow-up.vue';
export { default as DtIconChevronDown } from './src/icons/chevron-down.vue';
export { default as DtIconChevronFirst } from './src/icons/chevron-first.vue';
export { default as DtIconChevronLast } from './src/icons/chevron-last.vue';
export { default as DtIconChevronLeft } from './src/icons/chevron-left.vue';
export { default as DtIconChevronRight } from './src/icons/chevron-right.vue';
export { default as DtIconChevronUp } from './src/icons/chevron-up.vue';
export { default as DtIconChevronsDownUp } from './src/icons/chevrons-down-up.vue';
export { default as DtIconChevronsDown } from './src/icons/chevrons-down.vue';
export { default as DtIconChevronsLeftRight } from './src/icons/chevrons-left-right.vue';
export { default as DtIconChevronsLeft } from './src/icons/chevrons-left.vue';
export { default as DtIconChevronsRightLeft } from './src/icons/chevrons-right-left.vue';
export { default as DtIconChevronsRight } from './src/icons/chevrons-right.vue';
export { default as DtIconChevronsUpDown } from './src/icons/chevrons-up-down.vue';
export { default as DtIconChevronsUp } from './src/icons/chevrons-up.vue';
export { default as DtIconCornerDownLeft } from './src/icons/corner-down-left.vue';
export { default as DtIconCornerDownRight } from './src/icons/corner-down-right.vue';
export { default as DtIconCornerLeftDown } from './src/icons/corner-left-down.vue';
export { default as DtIconCornerLeftUp } from './src/icons/corner-left-up.vue';
export { default as DtIconCornerRightDown } from './src/icons/corner-right-down.vue';
export { default as DtIconCornerRightUp } from './src/icons/corner-right-up.vue';
export { default as DtIconCornerUpLeft } from './src/icons/corner-up-left.vue';
export { default as DtIconCornerUpRight } from './src/icons/corner-up-right.vue';
export { default as DtIconRedo } from './src/icons/redo.vue';
export { default as DtIconRematch } from './src/icons/rematch.vue';
export { default as DtIconRepeat } from './src/icons/repeat.vue';
export { default as DtIconReply } from './src/icons/reply.vue';
export { default as DtIconUndo2 } from './src/icons/undo-2.vue';
export { default as DtIconAgentAssistColor } from './src/icons/agent-assist-color.vue';
export { default as DtIconAirtable } from './src/icons/airtable.vue';
export { default as DtIconAmex } from './src/icons/amex.vue';
export { default as DtIconAppStoreBadge } from './src/icons/app-store-badge.vue';
export { default as DtIconApple } from './src/icons/apple.vue';
export { default as DtIconAsana } from './src/icons/asana.vue';
export { default as DtIconBrandDialpadMeetings } from './src/icons/brand-dialpad-meetings.vue';
export { default as DtIconBrandDialpad } from './src/icons/brand-dialpad.vue';
export { default as DtIconBullhorn } from './src/icons/bullhorn.vue';
export { default as DtIconClockify } from './src/icons/clockify.vue';
export { default as DtIconCompassColor } from './src/icons/compass-color.vue';
export { default as DtIconCopperCrm } from './src/icons/copper-crm.vue';
export { default as DtIconDialbot } from './src/icons/dialbot.vue';
export { default as DtIconDialpadAiColorReversed } from './src/icons/dialpad-ai-color-reversed.vue';
export { default as DtIconDialpadAiColor } from './src/icons/dialpad-ai-color.vue';
export { default as DtIconDialpadAnalyticsAi } from './src/icons/dialpad-analytics-ai.vue';
export { default as DtIconDialpadLogo } from './src/icons/dialpad-logo.vue';
export { default as DtIconDialpadSparkle } from './src/icons/dialpad-sparkle.vue';
export { default as DtIconDialpadStarMarkColor } from './src/icons/dialpad-star-mark-color.vue';
export { default as DtIconDinersClub } from './src/icons/diners-club.vue';
export { default as DtIconDiscover } from './src/icons/discover.vue';
export { default as DtIconDpmLogo } from './src/icons/dpm-logo.vue';
export { default as DtIconEvernote } from './src/icons/evernote.vue';
export { default as DtIconFacebook } from './src/icons/facebook.vue';
export { default as DtIconFigma } from './src/icons/figma.vue';
export { default as DtIconFreshdesk } from './src/icons/freshdesk.vue';
export { default as DtIconFreshsalesCrm } from './src/icons/freshsales-crm.vue';
export { default as DtIconFront } from './src/icons/front.vue';
export { default as DtIconGiphy } from './src/icons/giphy.vue';
export { default as DtIconGmail } from './src/icons/gmail.vue';
export { default as DtIconGoogleBusinessMessaging } from './src/icons/google-business-messaging.vue';
export { default as DtIconGoogleCalendar } from './src/icons/google-calendar.vue';
export { default as DtIconGoogleDocs } from './src/icons/google-docs.vue';
export { default as DtIconGoogleDrive } from './src/icons/google-drive.vue';
export { default as DtIconGoogleGlyph } from './src/icons/google-glyph.vue';
export { default as DtIconGoogleMeet } from './src/icons/google-meet.vue';
export { default as DtIconGoogleSheets } from './src/icons/google-sheets.vue';
export { default as DtIconGoogleSlides } from './src/icons/google-slides.vue';
export { default as DtIconGreenhouse } from './src/icons/greenhouse.vue';
export { default as DtIconHighfive } from './src/icons/highfive.vue';
export { default as DtIconHubspot } from './src/icons/hubspot.vue';
export { default as DtIconInstagram } from './src/icons/instagram.vue';
export { default as DtIconIntercom } from './src/icons/intercom.vue';
export { default as DtIconJcb } from './src/icons/jcb.vue';
export { default as DtIconJiraServiceDesk } from './src/icons/jira-service-desk.vue';
export { default as DtIconLineMessenger } from './src/icons/line-messenger.vue';
export { default as DtIconLinkedin } from './src/icons/linkedin.vue';
export { default as DtIconMaestro } from './src/icons/maestro.vue';
export { default as DtIconMastercard } from './src/icons/mastercard.vue';
export { default as DtIconMessenger } from './src/icons/messenger.vue';
export { default as DtIconMicrosoftDynamics365 } from './src/icons/microsoft-dynamics-365.vue';
export { default as DtIconMicrosoftTeams } from './src/icons/microsoft-teams.vue';
export { default as DtIconMicrosoft } from './src/icons/microsoft.vue';
export { default as DtIconMiro } from './src/icons/miro.vue';
export { default as DtIconMondayCom } from './src/icons/monday-com.vue';
export { default as DtIconO365Calendar } from './src/icons/o365-calendar.vue';
export { default as DtIconOffice365 } from './src/icons/office-365.vue';
export { default as DtIconPipedrive } from './src/icons/pipedrive.vue';
export { default as DtIconPlayStoreBadge } from './src/icons/play-store-badge.vue';
export { default as DtIconSalesforceGlyph } from './src/icons/salesforce-glyph.vue';
export { default as DtIconSalesforceLogo } from './src/icons/salesforce-logo.vue';
export { default as DtIconServicenow } from './src/icons/servicenow.vue';
export { default as DtIconSlack } from './src/icons/slack.vue';
export { default as DtIconSnapchat } from './src/icons/snapchat.vue';
export { default as DtIconStorybookColor } from './src/icons/storybook-color.vue';
export { default as DtIconTMobile } from './src/icons/t-mobile.vue';
export { default as DtIconTelegram } from './src/icons/telegram.vue';
export { default as DtIconThreads } from './src/icons/threads.vue';
export { default as DtIconTiktok } from './src/icons/tiktok.vue';
export { default as DtIconToggl } from './src/icons/toggl.vue';
export { default as DtIconTwitter } from './src/icons/twitter.vue';
export { default as DtIconUnionPay } from './src/icons/union-pay.vue';
export { default as DtIconViber } from './src/icons/viber.vue';
export { default as DtIconVisa } from './src/icons/visa.vue';
export { default as DtIconWeChat } from './src/icons/we-chat.vue';
export { default as DtIconWebex } from './src/icons/webex.vue';
export { default as DtIconWhatsapp } from './src/icons/whatsapp.vue';
export { default as DtIconXBrand } from './src/icons/x-brand.vue';
export { default as DtIconZendesk } from './src/icons/zendesk.vue';
export { default as DtIconZohoCrm } from './src/icons/zoho-crm.vue';
export { default as DtIconZohoDesk } from './src/icons/zoho-desk.vue';
export { default as DtIconZoho } from './src/icons/zoho.vue';
export { default as DtIconZoom } from './src/icons/zoom.vue';
export { default as DtIconAgentAssist } from './src/icons/agent-assist.vue';
export { default as DtIconAiNotes } from './src/icons/ai-notes.vue';
export { default as DtIconCoachingHub } from './src/icons/coaching-hub.vue';
export { default as DtIconCodepen } from './src/icons/codepen.vue';
export { default as DtIconDefaultAiAgentFab } from './src/icons/default-ai-agent-fab.vue';
export { default as DtIconDialpadAiReversed } from './src/icons/dialpad-ai-reversed.vue';
export { default as DtIconDialpadAi } from './src/icons/dialpad-ai.vue';
export { default as DtIconDialpadLogomark } from './src/icons/dialpad-logomark.vue';
export { default as DtIconDialpadMeetingsStar } from './src/icons/dialpad-meetings-star.vue';
export { default as DtIconDialpadStarMark } from './src/icons/dialpad-star-mark.vue';
export { default as DtIconDialpadStarReversed } from './src/icons/dialpad-star-reversed.vue';
export { default as DtIconDialpadStar } from './src/icons/dialpad-star.vue';
export { default as DtIconDialpadWfm } from './src/icons/dialpad-wfm.vue';
export { default as DtIconDpPhone } from './src/icons/dp-phone.vue';
export { default as DtIconGithub } from './src/icons/github.vue';
export { default as DtIconStorybook } from './src/icons/storybook.vue';
export { default as DtIconWaveform } from './src/icons/waveform.vue';
export { default as DtIconZoomLogo } from './src/icons/zoom-logo.vue';
export { default as DtIconCallAbandoned } from './src/icons/call-abandoned.vue';
export { default as DtIconCallRejected } from './src/icons/call-rejected.vue';
export { default as DtIconContacts } from './src/icons/contacts.vue';
export { default as DtIconDialer } from './src/icons/dialer.vue';
export { default as DtIconDigitalWhisper } from './src/icons/digital-whisper.vue';
export { default as DtIconForward } from './src/icons/forward.vue';
export { default as DtIconHandFilled } from './src/icons/hand-filled.vue';
export { default as DtIconHand } from './src/icons/hand.vue';
export { default as DtIconListening } from './src/icons/listening.vue';
export { default as DtIconMailOpen } from './src/icons/mail-open.vue';
export { default as DtIconMail } from './src/icons/mail.vue';
export { default as DtIconMails } from './src/icons/mails.vue';
export { default as DtIconMessage } from './src/icons/message.vue';
export { default as DtIconMusic } from './src/icons/music.vue';
export { default as DtIconNotes } from './src/icons/notes.vue';
export { default as DtIconPastConversations } from './src/icons/past-conversations.vue';
export { default as DtIconPhoneCall } from './src/icons/phone-call.vue';
export { default as DtIconPhoneForward } from './src/icons/phone-forward.vue';
export { default as DtIconPhoneHold } from './src/icons/phone-hold.vue';
export { default as DtIconPhoneIncoming } from './src/icons/phone-incoming.vue';
export { default as DtIconPhoneMissed } from './src/icons/phone-missed.vue';
export { default as DtIconPhoneOff } from './src/icons/phone-off.vue';
export { default as DtIconPhoneOutgoing } from './src/icons/phone-outgoing.vue';
export { default as DtIconPhone } from './src/icons/phone.vue';
export { default as DtIconPowerDialerOff } from './src/icons/power-dialer-off.vue';
export { default as DtIconPowerDialer } from './src/icons/power-dialer.vue';
export { default as DtIconQuickReply } from './src/icons/quick-reply.vue';
export { default as DtIconReplyAll } from './src/icons/reply-all.vue';
export { default as DtIconSend } from './src/icons/send.vue';
export { default as DtIconSimultaneousRing } from './src/icons/simultaneous-ring.vue';
export { default as DtIconThread } from './src/icons/thread.vue';
export { default as DtIconUnread } from './src/icons/unread.vue';
export { default as DtIconVoicemailDrop } from './src/icons/voicemail-drop.vue';
export { default as DtIconVoicemail } from './src/icons/voicemail.vue';
export { default as DtIconWebchat } from './src/icons/webchat.vue';
export { default as DtIconWhisper } from './src/icons/whisper.vue';
export { default as DtIconBarge } from './src/icons/barge.vue';
export { default as DtIconBlurBackground } from './src/icons/blur-background.vue';
export { default as DtIconCircleSlashed } from './src/icons/circle-slashed.vue';
export { default as DtIconDelete } from './src/icons/delete.vue';
export { default as DtIconDownload } from './src/icons/download.vue';
export { default as DtIconEndChat } from './src/icons/end-chat.vue';
export { default as DtIconExpand } from './src/icons/expand.vue';
export { default as DtIconEyeOff } from './src/icons/eye-off.vue';
export { default as DtIconEye } from './src/icons/eye.vue';
export { default as DtIconFastForward } from './src/icons/fast-forward.vue';
export { default as DtIconFilterFilled } from './src/icons/filter-filled.vue';
export { default as DtIconFilter } from './src/icons/filter.vue';
export { default as DtIconFood } from './src/icons/food.vue';
export { default as DtIconGamepad } from './src/icons/gamepad.vue';
export { default as DtIconGifFilled } from './src/icons/gif-filled.vue';
export { default as DtIconGifOutline } from './src/icons/gif-outline.vue';
export { default as DtIconGrid } from './src/icons/grid.vue';
export { default as DtIconGripHorizontal } from './src/icons/grip-horizontal.vue';
export { default as DtIconGripVertical } from './src/icons/grip-vertical.vue';
export { default as DtIconHear } from './src/icons/hear.vue';
export { default as DtIconHeart } from './src/icons/heart.vue';
export { default as DtIconHistory } from './src/icons/history.vue';
export { default as DtIconHold } from './src/icons/hold.vue';
export { default as DtIconKey } from './src/icons/key.vue';
export { default as DtIconLargeSelfView } from './src/icons/large-self-view.vue';
export { default as DtIconLayoutDashboard } from './src/icons/layout-dashboard.vue';
export { default as DtIconLayoutFilmstrip } from './src/icons/layout-filmstrip.vue';
export { default as DtIconLayoutGrid } from './src/icons/layout-grid.vue';
export { default as DtIconLayoutTemplate } from './src/icons/layout-template.vue';
export { default as DtIconLayout } from './src/icons/layout.vue';
export { default as DtIconLightbulbOff } from './src/icons/lightbulb-off.vue';
export { default as DtIconLightbulb } from './src/icons/lightbulb.vue';
export { default as DtIconListen } from './src/icons/listen.vue';
export { default as DtIconLivingThing } from './src/icons/living-thing.vue';
export { default as DtIconLockFilled } from './src/icons/lock-filled.vue';
export { default as DtIconLock } from './src/icons/lock.vue';
export { default as DtIconMaximize } from './src/icons/maximize.vue';
export { default as DtIconMenu } from './src/icons/menu.vue';
export { default as DtIconMinimizeAlt } from './src/icons/minimize-alt.vue';
export { default as DtIconMinimize } from './src/icons/minimize.vue';
export { default as DtIconMinusCircle } from './src/icons/minus-circle.vue';
export { default as DtIconMinus } from './src/icons/minus.vue';
export { default as DtIconMultiLineDept } from './src/icons/multi-line-dept.vue';
export { default as DtIconMusicOff } from './src/icons/music-off.vue';
export { default as DtIconObject } from './src/icons/object.vue';
export { default as DtIconOption } from './src/icons/option.vue';
export { default as DtIconPark } from './src/icons/park.vue';
export { default as DtIconPauseCircleFilled } from './src/icons/pause-circle-filled.vue';
export { default as DtIconPauseCircle } from './src/icons/pause-circle.vue';
export { default as DtIconPause } from './src/icons/pause.vue';
export { default as DtIconPhoneHangUp } from './src/icons/phone-hang-up.vue';
export { default as DtIconPictureInPicture } from './src/icons/picture-in-picture.vue';
export { default as DtIconPinFilled } from './src/icons/pin-filled.vue';
export { default as DtIconPinOff } from './src/icons/pin-off.vue';
export { default as DtIconPin } from './src/icons/pin.vue';
export { default as DtIconPlayCircleFilled } from './src/icons/play-circle-filled.vue';
export { default as DtIconPlayCircle } from './src/icons/play-circle.vue';
export { default as DtIconPlayFilled } from './src/icons/play-filled.vue';
export { default as DtIconPlay } from './src/icons/play.vue';
export { default as DtIconPlusCircleFilled } from './src/icons/plus-circle-filled.vue';
export { default as DtIconPlusCircle } from './src/icons/plus-circle.vue';
export { default as DtIconPlus } from './src/icons/plus.vue';
export { default as DtIconRecordFilled } from './src/icons/record-filled.vue';
export { default as DtIconRecord } from './src/icons/record.vue';
export { default as DtIconRefresh } from './src/icons/refresh.vue';
export { default as DtIconRewind15Sec } from './src/icons/rewind-15-sec.vue';
export { default as DtIconRewind } from './src/icons/rewind.vue';
export { default as DtIconSearch } from './src/icons/search.vue';
export { default as DtIconShare } from './src/icons/share.vue';
export { default as DtIconSheet } from './src/icons/sheet.vue';
export { default as DtIconShortcuts } from './src/icons/shortcuts.vue';
export { default as DtIconShuffle } from './src/icons/shuffle.vue';
export { default as DtIconSidebarClose } from './src/icons/sidebar-close.vue';
export { default as DtIconSidebarOpen } from './src/icons/sidebar-open.vue';
export { default as DtIconSidebar } from './src/icons/sidebar.vue';
export { default as DtIconSkip15Sec } from './src/icons/skip-15-sec.vue';
export { default as DtIconSkipBackTen } from './src/icons/skip-back-ten.vue';
export { default as DtIconSkipBack } from './src/icons/skip-back.vue';
export { default as DtIconSkipForwardTen } from './src/icons/skip-forward-ten.vue';
export { default as DtIconSkipForward } from './src/icons/skip-forward.vue';
export { default as DtIconSlidersHorizontal } from './src/icons/sliders-horizontal.vue';
export { default as DtIconSliders } from './src/icons/sliders.vue';
export { default as DtIconSmallSelfView } from './src/icons/small-self-view.vue';
export { default as DtIconSortAsc } from './src/icons/sort-asc.vue';
export { default as DtIconSortDesc } from './src/icons/sort-desc.vue';
export { default as DtIconSticker } from './src/icons/sticker.vue';
export { default as DtIconStopCircleFilled } from './src/icons/stop-circle-filled.vue';
export { default as DtIconStopCircle } from './src/icons/stop-circle.vue';
export { default as DtIconStopFilled } from './src/icons/stop-filled.vue';
export { default as DtIconTable } from './src/icons/table.vue';
export { default as DtIconTakeover } from './src/icons/takeover.vue';
export { default as DtIconTransferWebchat } from './src/icons/transfer-webchat.vue';
export { default as DtIconTransfer } from './src/icons/transfer.vue';
export { default as DtIconTransportation } from './src/icons/transportation.vue';
export { default as DtIconTrash } from './src/icons/trash.vue';
export { default as DtIconUnlockFilled } from './src/icons/unlock-filled.vue';
export { default as DtIconUnlock } from './src/icons/unlock.vue';
export { default as DtIconXCircle } from './src/icons/x-circle.vue';
export { default as DtIconZoomIn } from './src/icons/zoom-in.vue';
export { default as DtIconZoomOut } from './src/icons/zoom-out.vue';
export { default as DtIconActivity } from './src/icons/activity.vue';
export { default as DtIconAxis3d } from './src/icons/axis-3d.vue';
export { default as DtIconBarChart2 } from './src/icons/bar-chart-2.vue';
export { default as DtIconBarChart3 } from './src/icons/bar-chart-3.vue';
export { default as DtIconBarChart4 } from './src/icons/bar-chart-4.vue';
export { default as DtIconBarChartHorizontal } from './src/icons/bar-chart-horizontal.vue';
export { default as DtIconBarChart } from './src/icons/bar-chart.vue';
export { default as DtIconBinary } from './src/icons/binary.vue';
export { default as DtIconDash } from './src/icons/dash.vue';
export { default as DtIconEqual } from './src/icons/equal.vue';
export { default as DtIconLineChart } from './src/icons/line-chart.vue';
export { default as DtIconLiveQueue } from './src/icons/live-queue.vue';
export { default as DtIconPieChart } from './src/icons/pie-chart.vue';
export { default as DtIconTrendingDown } from './src/icons/trending-down.vue';
export { default as DtIconTrendingUp } from './src/icons/trending-up.vue';
export { default as DtIconAirplay } from './src/icons/airplay.vue';
export { default as DtIconAtaAdapter } from './src/icons/ata-adapter.vue';
export { default as DtIconBatteryCharging } from './src/icons/battery-charging.vue';
export { default as DtIconBatteryFull } from './src/icons/battery-full.vue';
export { default as DtIconBatteryLow } from './src/icons/battery-low.vue';
export { default as DtIconBatteryMedium } from './src/icons/battery-medium.vue';
export { default as DtIconBattery } from './src/icons/battery.vue';
export { default as DtIconBluetoothConnected } from './src/icons/bluetooth-connected.vue';
export { default as DtIconBluetoothOff } from './src/icons/bluetooth-off.vue';
export { default as DtIconBluetoothSearching } from './src/icons/bluetooth-searching.vue';
export { default as DtIconBluetooth } from './src/icons/bluetooth.vue';
export { default as DtIconCalculator } from './src/icons/calculator.vue';
export { default as DtIconCameraOff } from './src/icons/camera-off.vue';
export { default as DtIconCameraTracking } from './src/icons/camera-tracking.vue';
export { default as DtIconCamera } from './src/icons/camera.vue';
export { default as DtIconCast } from './src/icons/cast.vue';
export { default as DtIconConnectionApi } from './src/icons/connection-api.vue';
export { default as DtIconDectBaseStation } from './src/icons/dect-base-station.vue';
export { default as DtIconDectHandset } from './src/icons/dect-handset.vue';
export { default as DtIconDeskphone } from './src/icons/deskphone.vue';
export { default as DtIconDownloadCloud } from './src/icons/download-cloud.vue';
export { default as DtIconFaxInbound } from './src/icons/fax-inbound.vue';
export { default as DtIconFaxOutbound } from './src/icons/fax-outbound.vue';
export { default as DtIconFileAudio } from './src/icons/file-audio.vue';
export { default as DtIconFilm } from './src/icons/film.vue';
export { default as DtIconFocus } from './src/icons/focus.vue';
export { default as DtIconHd } from './src/icons/hd.vue';
export { default as DtIconHeadphones } from './src/icons/headphones.vue';
export { default as DtIconHeadset } from './src/icons/headset.vue';
export { default as DtIconLaptop2 } from './src/icons/laptop-2.vue';
export { default as DtIconLightningBolt } from './src/icons/lightning-bolt.vue';
export { default as DtIconMicOff } from './src/icons/mic-off.vue';
export { default as DtIconMic } from './src/icons/mic.vue';
export { default as DtIconMonitorOff } from './src/icons/monitor-off.vue';
export { default as DtIconMonitorSpeaker } from './src/icons/monitor-speaker.vue';
export { default as DtIconMonitor } from './src/icons/monitor.vue';
export { default as DtIconMouse } from './src/icons/mouse.vue';
export { default as DtIconPlug } from './src/icons/plug.vue';
export { default as DtIconPrintFax } from './src/icons/print-fax.vue';
export { default as DtIconPrinter } from './src/icons/printer.vue';
export { default as DtIconScreenShareOff } from './src/icons/screen-share-off.vue';
export { default as DtIconShareScreen } from './src/icons/share-screen.vue';
export { default as DtIconSmartphoneCharging } from './src/icons/smartphone-charging.vue';
export { default as DtIconSmartphone } from './src/icons/smartphone.vue';
export { default as DtIconSpeaker } from './src/icons/speaker.vue';
export { default as DtIconSwitchToCellular } from './src/icons/switch-to-cellular.vue';
export { default as DtIconSwitchToHd } from './src/icons/switch-to-hd.vue';
export { default as DtIconUsb } from './src/icons/usb.vue';
export { default as DtIconVideoOff } from './src/icons/video-off.vue';
export { default as DtIconVideo } from './src/icons/video.vue';
export { default as DtIconVolume1 } from './src/icons/volume-1.vue';
export { default as DtIconVolume2 } from './src/icons/volume-2.vue';
export { default as DtIconVolumeX } from './src/icons/volume-x.vue';
export { default as DtIconVolume } from './src/icons/volume.vue';
export { default as DtIconWebcam } from './src/icons/webcam.vue';
export { default as DtIconWifiOff } from './src/icons/wifi-off.vue';
export { default as DtIconWifi } from './src/icons/wifi.vue';
export { default as DtIconZapOff } from './src/icons/zap-off.vue';
export { default as DtIconAiWrite } from './src/icons/ai-write.vue';
export { default as DtIconAlignCenter } from './src/icons/align-center.vue';
export { default as DtIconAlignJustify } from './src/icons/align-justify.vue';
export { default as DtIconAlignLeft } from './src/icons/align-left.vue';
export { default as DtIconAlignRight } from './src/icons/align-right.vue';
export { default as DtIconAsterisk } from './src/icons/asterisk.vue';
export { default as DtIconAtSign } from './src/icons/at-sign.vue';
export { default as DtIconBaseline } from './src/icons/baseline.vue';
export { default as DtIconBold } from './src/icons/bold.vue';
export { default as DtIconBraces } from './src/icons/braces.vue';
export { default as DtIconBranch } from './src/icons/branch.vue';
export { default as DtIconCallMerge } from './src/icons/call-merge.vue';
export { default as DtIconCodeBlock } from './src/icons/code-block.vue';
export { default as DtIconEdit2 } from './src/icons/edit-2.vue';
export { default as DtIconEdit } from './src/icons/edit.vue';
export { default as DtIconEraser } from './src/icons/eraser.vue';
export { default as DtIconExpertNode } from './src/icons/expert-node.vue';
export { default as DtIconFontSize } from './src/icons/font-size.vue';
export { default as DtIconImage } from './src/icons/image.vue';
export { default as DtIconIndent } from './src/icons/indent.vue';
export { default as DtIconInspect } from './src/icons/inspect.vue';
export { default as DtIconItalic } from './src/icons/italic.vue';
export { default as DtIconKeyboard } from './src/icons/keyboard.vue';
export { default as DtIconLink2Off } from './src/icons/link-2-off.vue';
export { default as DtIconLink2 } from './src/icons/link-2.vue';
export { default as DtIconListAdd } from './src/icons/list-add.vue';
export { default as DtIconListBullet } from './src/icons/list-bullet.vue';
export { default as DtIconListChecks } from './src/icons/list-checks.vue';
export { default as DtIconListChevronsDownUp } from './src/icons/list-chevrons-down-up.vue';
export { default as DtIconListChevronsUpDown } from './src/icons/list-chevrons-up-down.vue';
export { default as DtIconListOrdered } from './src/icons/list-ordered.vue';
export { default as DtIconListSpacingCompact } from './src/icons/list-spacing-compact.vue';
export { default as DtIconListSpacingExpanded } from './src/icons/list-spacing-expanded.vue';
export { default as DtIconListSpacingRegular } from './src/icons/list-spacing-regular.vue';
export { default as DtIconPaintBucket } from './src/icons/paint-bucket.vue';
export { default as DtIconPaperclip } from './src/icons/paperclip.vue';
export { default as DtIconQuote } from './src/icons/quote.vue';
export { default as DtIconScissors } from './src/icons/scissors.vue';
export { default as DtIconStrikethrough } from './src/icons/strikethrough.vue';
export { default as DtIconTextCursor } from './src/icons/text-cursor.vue';
export { default as DtIconType } from './src/icons/type.vue';
export { default as DtIconUnderline } from './src/icons/underline.vue';
export { default as DtIconUnlink2 } from './src/icons/unlink-2.vue';
export { default as DtIconVariable } from './src/icons/variable.vue';
export { default as DtIconAccessibilityMac } from './src/icons/accessibility-mac.vue';
export { default as DtIconAccessibility } from './src/icons/accessibility.vue';
export { default as DtIconAddTask } from './src/icons/add-task.vue';
export { default as DtIconAlbum } from './src/icons/album.vue';
export { default as DtIconArchiveRestore } from './src/icons/archive-restore.vue';
export { default as DtIconArchive } from './src/icons/archive.vue';
export { default as DtIconAttestationOutline } from './src/icons/attestation-outline.vue';
export { default as DtIconAttestation } from './src/icons/attestation.vue';
export { default as DtIconBookOpen } from './src/icons/book-open.vue';
export { default as DtIconBook } from './src/icons/book.vue';
export { default as DtIconBookmarkFilled } from './src/icons/bookmark-filled.vue';
export { default as DtIconBookmarkMinus } from './src/icons/bookmark-minus.vue';
export { default as DtIconBookmarkPlus } from './src/icons/bookmark-plus.vue';
export { default as DtIconBookmark } from './src/icons/bookmark.vue';
export { default as DtIconBoxSelect } from './src/icons/box-select.vue';
export { default as DtIconBox } from './src/icons/box.vue';
export { default as DtIconBoxes } from './src/icons/boxes.vue';
export { default as DtIconBreakoutRooms } from './src/icons/breakout-rooms.vue';
export { default as DtIconBullet } from './src/icons/bullet.vue';
export { default as DtIconCheckCircleFilled } from './src/icons/check-circle-filled.vue';
export { default as DtIconCheckCircle } from './src/icons/check-circle.vue';
export { default as DtIconCheck } from './src/icons/check.vue';
export { default as DtIconCircleDashed } from './src/icons/circle-dashed.vue';
export { default as DtIconCircleHalfFilled } from './src/icons/circle-half-filled.vue';
export { default as DtIconCircle } from './src/icons/circle.vue';
export { default as DtIconClose } from './src/icons/close.vue';
export { default as DtIconCode } from './src/icons/code.vue';
export { default as DtIconCompass } from './src/icons/compass.vue';
export { default as DtIconComponent } from './src/icons/component.vue';
export { default as DtIconCopy } from './src/icons/copy.vue';
export { default as DtIconCopyright } from './src/icons/copyright.vue';
export { default as DtIconCreditCard } from './src/icons/credit-card.vue';
export { default as DtIconDissatisfiedFilled } from './src/icons/dissatisfied-filled.vue';
export { default as DtIconDissatisfied } from './src/icons/dissatisfied.vue';
export { default as DtIconDoubleCheck } from './src/icons/double-check.vue';
export { default as DtIconEmpty } from './src/icons/empty.vue';
export { default as DtIconFlagOff } from './src/icons/flag-off.vue';
export { default as DtIconFlag } from './src/icons/flag.vue';
export { default as DtIconFormInput } from './src/icons/form-input.vue';
export { default as DtIconGauge } from './src/icons/gauge.vue';
export { default as DtIconGraduation } from './src/icons/graduation.vue';
export { default as DtIconHashBold } from './src/icons/hash-bold.vue';
export { default as DtIconHash } from './src/icons/hash.vue';
export { default as DtIconHelpCircle } from './src/icons/help-circle.vue';
export { default as DtIconInbox } from './src/icons/inbox.vue';
export { default as DtIconInfo } from './src/icons/info.vue';
export { default as DtIconIsolatedQueries } from './src/icons/isolated-queries.vue';
export { default as DtIconKeypad } from './src/icons/keypad.vue';
export { default as DtIconLibrary } from './src/icons/library.vue';
export { default as DtIconLogIn } from './src/icons/log-in.vue';
export { default as DtIconLogOut } from './src/icons/log-out.vue';
export { default as DtIconMoreHorizontal } from './src/icons/more-horizontal.vue';
export { default as DtIconMoreVertical } from './src/icons/more-vertical.vue';
export { default as DtIconNetwork } from './src/icons/network.vue';
export { default as DtIconNeutral } from './src/icons/neutral.vue';
export { default as DtIconNotEnoughQueries } from './src/icons/not-enough-queries.vue';
export { default as DtIconPackage } from './src/icons/package.vue';
export { default as DtIconPartyPopper } from './src/icons/party-popper.vue';
export { default as DtIconPower } from './src/icons/power.vue';
export { default as DtIconPuzzle } from './src/icons/puzzle.vue';
export { default as DtIconQueries } from './src/icons/queries.vue';
export { default as DtIconRocket } from './src/icons/rocket.vue';
export { default as DtIconSatisfiedFilled } from './src/icons/satisfied-filled.vue';
export { default as DtIconSatisfied } from './src/icons/satisfied.vue';
export { default as DtIconScroll } from './src/icons/scroll.vue';
export { default as DtIconSettings } from './src/icons/settings.vue';
export { default as DtIconShieldAlert } from './src/icons/shield-alert.vue';
export { default as DtIconShieldCheck } from './src/icons/shield-check.vue';
export { default as DtIconShieldClose } from './src/icons/shield-close.vue';
export { default as DtIconShieldOff } from './src/icons/shield-off.vue';
export { default as DtIconShield } from './src/icons/shield.vue';
export { default as DtIconSomewhatDissatisfiedFilled } from './src/icons/somewhat-dissatisfied-filled.vue';
export { default as DtIconSomewhatDissatisfied } from './src/icons/somewhat-dissatisfied.vue';
export { default as DtIconSomewhatSatisfiedFilled } from './src/icons/somewhat-satisfied-filled.vue';
export { default as DtIconSomewhatSatisfied } from './src/icons/somewhat-satisfied.vue';
export { default as DtIconSparkleFilled } from './src/icons/sparkle-filled.vue';
export { default as DtIconSparkle } from './src/icons/sparkle.vue';
export { default as DtIconStarFilled } from './src/icons/star-filled.vue';
export { default as DtIconStar } from './src/icons/star.vue';
export { default as DtIconTag } from './src/icons/tag.vue';
export { default as DtIconTags } from './src/icons/tags.vue';
export { default as DtIconTask } from './src/icons/task.vue';
export { default as DtIconTextCursorInput } from './src/icons/text-cursor-input.vue';
export { default as DtIconThumbsDownFilled } from './src/icons/thumbs-down-filled.vue';
export { default as DtIconThumbsDown } from './src/icons/thumbs-down.vue';
export { default as DtIconThumbsUpFilled } from './src/icons/thumbs-up-filled.vue';
export { default as DtIconThumbsUp } from './src/icons/thumbs-up.vue';
export { default as DtIconTooManyQueries } from './src/icons/too-many-queries.vue';
export { default as DtIconTools } from './src/icons/tools.vue';
export { default as DtIconTriangle } from './src/icons/triangle.vue';
export { default as DtIconVeryDissatisfiedFilled } from './src/icons/very-dissatisfied-filled.vue';
export { default as DtIconVeryDissatisfied } from './src/icons/very-dissatisfied.vue';
export { default as DtIconVerySatisfiedFilled } from './src/icons/very-satisfied-filled.vue';
export { default as DtIconVerySatisfied } from './src/icons/very-satisfied.vue';
export { default as DtIconVideoSettings } from './src/icons/video-settings.vue';
export { default as DtIconWhatsappOutlined } from './src/icons/whatsapp-outlined.vue';
export { default as DtIconClipboardCheck } from './src/icons/clipboard-check.vue';
export { default as DtIconClipboardCopy } from './src/icons/clipboard-copy.vue';
export { default as DtIconClipboardEdit } from './src/icons/clipboard-edit.vue';
export { default as DtIconClipboardList } from './src/icons/clipboard-list.vue';
export { default as DtIconClipboardSignature } from './src/icons/clipboard-signature.vue';
export { default as DtIconClipboardType } from './src/icons/clipboard-type.vue';
export { default as DtIconClipboardX } from './src/icons/clipboard-x.vue';
export { default as DtIconClipboard } from './src/icons/clipboard.vue';
export { default as DtIconCloudOff } from './src/icons/cloud-off.vue';
export { default as DtIconCommand } from './src/icons/command.vue';
export { default as DtIconCpu } from './src/icons/cpu.vue';
export { default as DtIconExternalLink } from './src/icons/external-link.vue';
export { default as DtIconFilePdf } from './src/icons/file-pdf.vue';
export { default as DtIconFileText } from './src/icons/file-text.vue';
export { default as DtIconFile } from './src/icons/file.vue';
export { default as DtIconFiles } from './src/icons/files.vue';
export { default as DtIconFingerprint } from './src/icons/fingerprint.vue';
export { default as DtIconFolderTree } from './src/icons/folder-tree.vue';
export { default as DtIconFolder } from './src/icons/folder.vue';
export { default as DtIconFolders } from './src/icons/folders.vue';
export { default as DtIconHardDrive } from './src/icons/hard-drive.vue';
export { default as DtIconImport } from './src/icons/import.vue';
export { default as DtIconLanguages } from './src/icons/languages.vue';
export { default as DtIconLifeBuoy } from './src/icons/life-buoy.vue';
export { default as DtIconQrCode } from './src/icons/qr-code.vue';
export { default as DtIconSave } from './src/icons/save.vue';
export { default as DtIconScanFace } from './src/icons/scan-face.vue';
export { default as DtIconScanFile } from './src/icons/scan-file.vue';
export { default as DtIconScan } from './src/icons/scan.vue';
export { default as DtIconShare2 } from './src/icons/share-2.vue';
export { default as DtIconSignalBest } from './src/icons/signal-best.vue';
export { default as DtIconSignalHigh } from './src/icons/signal-high.vue';
export { default as DtIconSignalLow } from './src/icons/signal-low.vue';
export { default as DtIconSignalMedium } from './src/icons/signal-medium.vue';
export { default as DtIconSignalZero } from './src/icons/signal-zero.vue';
export { default as DtIconSlash } from './src/icons/slash.vue';
export { default as DtIconToken } from './src/icons/token.vue';
export { default as DtIconToyBrick } from './src/icons/toy-brick.vue';
export { default as DtIconUploadCloud } from './src/icons/upload-cloud.vue';
export { default as DtIconUpload } from './src/icons/upload.vue';
export { default as DtIconUserCheck } from './src/icons/user-check.vue';
export { default as DtIconUserMinus } from './src/icons/user-minus.vue';
export { default as DtIconUserPlus } from './src/icons/user-plus.vue';
export { default as DtIconUserRematch } from './src/icons/user-rematch.vue';
export { default as DtIconUserRemove } from './src/icons/user-remove.vue';
export { default as DtIconUserSpeak } from './src/icons/user-speak.vue';
export { default as DtIconUser } from './src/icons/user.vue';
export { default as DtIconUsers } from './src/icons/users.vue';
export { default as DtIconBriefcase } from './src/icons/briefcase.vue';
export { default as DtIconBuilding2 } from './src/icons/building-2.vue';
export { default as DtIconBuilding } from './src/icons/building.vue';
export { default as DtIconFactory } from './src/icons/factory.vue';
export { default as DtIconGlobe2 } from './src/icons/globe-2.vue';
export { default as DtIconHome } from './src/icons/home.vue';
export { default as DtIconMapPinFilled } from './src/icons/map-pin-filled.vue';
export { default as DtIconMapPin } from './src/icons/map-pin.vue';
export { default as DtIconMap } from './src/icons/map.vue';
export { default as DtIconAlarmCheck } from './src/icons/alarm-check.vue';
export { default as DtIconAlarmClockOff } from './src/icons/alarm-clock-off.vue';
export { default as DtIconAlarmMinus } from './src/icons/alarm-minus.vue';
export { default as DtIconAlarmPlus } from './src/icons/alarm-plus.vue';
export { default as DtIconCalendarCheck2 } from './src/icons/calendar-check-2.vue';
export { default as DtIconCalendarCheck } from './src/icons/calendar-check.vue';
export { default as DtIconCalendarClock } from './src/icons/calendar-clock.vue';
export { default as DtIconCalendarDays } from './src/icons/calendar-days.vue';
export { default as DtIconCalendarHeart } from './src/icons/calendar-heart.vue';
export { default as DtIconCalendarMinus } from './src/icons/calendar-minus.vue';
export { default as DtIconCalendarOff } from './src/icons/calendar-off.vue';
export { default as DtIconCalendarPlus } from './src/icons/calendar-plus.vue';
export { default as DtIconCalendarRange } from './src/icons/calendar-range.vue';
export { default as DtIconCalendarSearch } from './src/icons/calendar-search.vue';
export { default as DtIconCalendarX } from './src/icons/calendar-x.vue';
export { default as DtIconCalendar } from './src/icons/calendar.vue';
export { default as DtIconClock1 } from './src/icons/clock-1.vue';
export { default as DtIconClock10 } from './src/icons/clock-10.vue';
export { default as DtIconClock11 } from './src/icons/clock-11.vue';
export { default as DtIconClock12 } from './src/icons/clock-12.vue';
export { default as DtIconClock2 } from './src/icons/clock-2.vue';
export { default as DtIconClock3 } from './src/icons/clock-3.vue';
export { default as DtIconClock4 } from './src/icons/clock-4.vue';
export { default as DtIconClock5 } from './src/icons/clock-5.vue';
export { default as DtIconClock6 } from './src/icons/clock-6.vue';
export { default as DtIconClock7 } from './src/icons/clock-7.vue';
export { default as DtIconClock8 } from './src/icons/clock-8.vue';
export { default as DtIconClock9 } from './src/icons/clock-9.vue';
export { default as DtIconClock } from './src/icons/clock.vue';
export { default as DtIconHourglass } from './src/icons/hourglass.vue';
export { default as DtIconInfinity } from './src/icons/infinity.vue';
export { default as DtIconLoading } from './src/icons/loading.vue';
export { default as DtIconTimerOff } from './src/icons/timer-off.vue';
export { default as DtIconTimerReset } from './src/icons/timer-reset.vue';
export { default as DtIconTimer } from './src/icons/timer.vue';
export { default as DtIconCloudCog } from './src/icons/cloud-cog.vue';
export { default as DtIconCloudDrizzle } from './src/icons/cloud-drizzle.vue';
export { default as DtIconCloudFog } from './src/icons/cloud-fog.vue';
export { default as DtIconCloudHail } from './src/icons/cloud-hail.vue';
export { default as DtIconCloudLightning } from './src/icons/cloud-lightning.vue';
export { default as DtIconCloudMoonRain } from './src/icons/cloud-moon-rain.vue';
export { default as DtIconCloudMoon } from './src/icons/cloud-moon.vue';
export { default as DtIconCloudRainWind } from './src/icons/cloud-rain-wind.vue';
export { default as DtIconCloudRain } from './src/icons/cloud-rain.vue';
export { default as DtIconCloudSnow } from './src/icons/cloud-snow.vue';
export { default as DtIconCloudSunRain } from './src/icons/cloud-sun-rain.vue';
export { default as DtIconCloudSun } from './src/icons/cloud-sun.vue';
export { default as DtIconCloud } from './src/icons/cloud.vue';
export { default as DtIconCloudy } from './src/icons/cloudy.vue';
export { default as DtIconHaze } from './src/icons/haze.vue';
export { default as DtIconMoon } from './src/icons/moon.vue';
export { default as DtIconSnowflake } from './src/icons/snowflake.vue';
export { default as DtIconSunDim } from './src/icons/sun-dim.vue';
export { default as DtIconSunMedium } from './src/icons/sun-medium.vue';
export { default as DtIconSun } from './src/icons/sun.vue';
export { default as DtIconSunrise } from './src/icons/sunrise.vue';
export { default as DtIconSunset } from './src/icons/sunset.vue';
export { default as DtIconThermometerSnowflake } from './src/icons/thermometer-snowflake.vue';
export { default as DtIconThermometerSun } from './src/icons/thermometer-sun.vue';
export { default as DtIconThermometer } from './src/icons/thermometer.vue';
export { default as DtIconUmbrella } from './src/icons/umbrella.vue';
export { default as DtIconWind } from './src/icons/wind.vue';
export const illustrations = import.meta.glob('./src/illustrations/*.vue', { eager: true, import: 'default' });
export { default as DtIllustrationAccessDenied } from './src/illustrations/access-denied.vue';
export { default as DtIllustrationAtomicPathway } from './src/illustrations/atomic-pathway.vue';
export { default as DtIllustrationBlackHole } from './src/illustrations/black-hole.vue';
export { default as DtIllustrationBlankSpace } from './src/illustrations/blank-space.vue';
export { default as DtIllustrationBrowserTableGraph } from './src/illustrations/browser-table-graph.vue';
export { default as DtIllustrationDialpadLogoBlack } from './src/illustrations/dialpad-logo-black.vue';
export { default as DtIllustrationDialpadLogoInverted } from './src/illustrations/dialpad-logo-inverted.vue';
export { default as DtIllustrationDialpadLogoWhite } from './src/illustrations/dialpad-logo-white.vue';
export { default as DtIllustrationDialpadLogo } from './src/illustrations/dialpad-logo.vue';
export { default as DtIllustrationDialpadMonoBlack } from './src/illustrations/dialpad-mono-black.vue';
export { default as DtIllustrationDialpadMonoInverted } from './src/illustrations/dialpad-mono-inverted.vue';
export { default as DtIllustrationDialpadMonoWhite } from './src/illustrations/dialpad-mono-white.vue';
export { default as DtIllustrationDialpadMono } from './src/illustrations/dialpad-mono.vue';
export { default as DtIllustrationFileUpload } from './src/illustrations/file-upload.vue';
export { default as DtIllustrationLoginError } from './src/illustrations/login-error.vue';
export { default as DtIllustrationMagnifier } from './src/illustrations/magnifier.vue';
export { default as DtIllustrationMicDetected } from './src/illustrations/mic-detected.vue';
export { default as DtIllustrationMind } from './src/illustrations/mind.vue';
export { default as DtIllustrationMobileFullNotifications } from './src/illustrations/mobile-full-notifications.vue';
export { default as DtIllustrationNewMeeting } from './src/illustrations/new-meeting.vue';
export { default as DtIllustrationNewMessage } from './src/illustrations/new-message.vue';
export { default as DtIllustrationNothingToSeeHere } from './src/illustrations/nothing-to-see-here.vue';
export { default as DtIllustrationOrbitalHarmony } from './src/illustrations/orbital-harmony.vue';
export { default as DtIllustrationPlaylist } from './src/illustrations/playlist.vue';
export { default as DtIllustrationPublishGraphic } from './src/illustrations/publish-graphic.vue';
export { default as DtIllustrationSomethingWentWrong } from './src/illustrations/something-went-wrong.vue';
export { default as DtIllustrationVectorVortex } from './src/illustrations/vector-vortex.vue';
export { default as DtIllustrationWirelessScreenshare } from './src/illustrations/wireless-screenshare.vue';
